<template>
  <div class="pg-badge">
    <slot></slot>
    <span class="pg-badge-count" :style="maxStyle" v-if="!hidden">{{ text }}</span>
  </div>
</template>
<script setup>
import { computed } from 'vue'
const props = defineProps({
  value: [String, Number],
  max: [Number],
  hidden: {
    type: Boolean,
    default: false,
  },
})

const text = computed(() => (props.value > props.max ? '…' : props.value))
const maxStyle = computed(() =>
  props.value > props.max
    ? {
        lineHeight: '8px',
        fontSize: '12px',
        fontWeight: 700,
      }
    : {}
)
</script>
<style lang="scss">
@import '../style/badge.scss';
</style>
